var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.entityId && _vm.formProps)?_c(_vm.formComponent,_vm._b({tag:"component",on:{"form-close":_vm.close}},'component',_vm.formProps,false)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }